<mat-toolbar>
    <div (click)="goBack()" *ngIf="showBackButton" class="icon_holder">
        <img alt="" id="menu_icon" src="../../../assets/images/back-arrow.svg">
    </div>
    <div class="search_container"></div>
    <div class="title d-flex flex-column align-items-start">
        <h1>{{title}}</h1>
        <div class="maj-text d-md-none">Mise à jour : {{dateBuild}}</div>
        <a *ngIf="showPartnerBtn" class="btn btn-primary mr-3 d-md-none"
           href="https://offrespartenaires.sportdanslaville.com" target="_blank">Les offres partenaires</a>
    </div>
    <span class="fill-space"></span>
    <div class="responsive-button">
      <button (click)="openModificationProfilePopup()" *ngIf="showLogoutBtn" class="btn btn-primary mr-3">Mettre à jour mes coordonnées</button>
      <button (click)="logout()" *ngIf="showLogoutBtn" class="btn btn-primary mr-3">Déconnexion</button>
    </div>
    <div class="responsive-menu">
      <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Icone du menu" class="d-flex align-items-center btn p-1 btn-primary mr-3">
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button (click)="openModificationProfilePopup()" mat-menu-item>
          <mat-icon>contact_page</mat-icon>
          <span>Mettre à jour mes coordonnées</span>
        </button>
        <button (click)="logout()" mat-menu-item>
          <mat-icon>logout</mat-icon>
          <span>Déconnexion</span>
        </button>
      </mat-menu>
    </div>
    <a *ngIf="showPartnerBtn" class="btn btn-primary mr-3 d-md-block d-none"
       href="https://offrespartenaires.sportdanslaville.com" target="_blank">Les offres partenaires</a>
    <div class="maj-text d-md-block d-none">Mise à jour : {{dateBuild}}</div>
    <div class="icon">
        <img alt="" src="../../../assets/images/logo_sport_ville.svg">
    </div>
</mat-toolbar>
